<template>
  <div class="gray-back" style="padding:.2rem 0 8rem 0" v-if="!loading">
    <div class="danwei-warp" v-if="row.score_status == 3">
      <div class="title">{{ row.danwei }}</div>
      <div class="saiqu" v-for="(item, index) in row.price_list">
        <div>{{item.grade}}星级：{{item.total}}人</div>
        <div>{{item.total}}*{{item.price}}={{item.total * item.price}}元</div>
      </div>
      <div class="saiqu">总计：{{row.order_price}}元</div>
    </div>
    <div class="danwei-warp" v-else>
      <div class="danwei-people" style="text-align: right" v-if="row.members > 0">
        <van-button  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)" @click="action(1)">已报名{{ row.members }}人，点击查看</van-button>
      </div>

      <div class="title">{{ row.danwei }}</div>
      <div class="saiqu">考试时间：{{ row.datetitle }}</div>
      <div class="saiqu" v-if="row.sai_baoming_id==0">报名截止时间：{{ row.baoming_enddate }}</div>
      <div class="saiqu" v-if="row.sai_baoming_id>0">赛场考级队伍：{{ row.sai_baoming_name }}</div>
      <div class="saiqu" v-if="row.sai_baoming_id>0">赛场考级项目：{{ row.sai_baoming_subject_name }}</div>
      <div class="saiqu" v-if="row.sai_baoming_id>0">赛场考级赛区：{{ row.sai_baoming_saiqu_name }}</div>
      <div class="saiqu" v-if="starText">本次考试星级：{{ starText }}</div>
      <div class="saiqu">考试地点：{{ row.province }}{{ row.city }} {{ row.address }}</div>
      <div class="saiqu" v-if="row.phone">联系人电话：{{ row.phone }}</div>
      <div class="saiqu" v-if="row.zhuyishixiang">特殊说明：{{ row.zhuyishixiang }}</div>

      <div class="saiqu" >考官：
        <span :key="key" v-for="(kg,key) in row.kaoguan"><br/>{{kg.name}} {{kg.phone}}</span>
      </div>

      <div class="saiqu" >监督：
        <span :key="key" v-for="(kg,key) in row.jiandu"><br/>{{kg.name}} {{kg.phone}}</span>
      </div>
    </div>



<!--    <div class="step-warp">-->
<!--      <van-steps direction="vertical" active-color="#00B388" :active="active">-->
<!--        <van-step>-->
<!--          <div class="step-li">-->
<!--            <div class="title">考试信息</div>-->
<!--            <p class="desc">考级批次信息</p>-->
<!--            <div class="right tiny-btn-0" @click="action(1)" v-if="row.status!=2">修改信息</div>-->
<!--          </div>-->
<!--        </van-step>-->
<!--        <van-step>-->
<!--          <div class="step-li">-->
<!--            <div class="title">人员信息</div>-->
<!--            <p class="desc">运动员考级报名管理</p>-->
<!--            <div class="right tiny-btn-1" style="top:0 !important;" @click="action(3)" v-if="row.status!=2">邀请卡管理</div>-->
<!--            <div class="right tiny-btn-0" style="top:30px" @click="action(2)" v-if="row.status!=2">考级人员申报</div>-->
<!--          </div>-->
<!--        </van-step>-->
<!--        <van-step>-->
<!--          <div class="step-li">-->
<!--            <div class="title">确认订单并支付</div>-->
<!--            <p class="desc">确认订单支付费用</p>-->
<!--            <div v-if="row.member_list.length>0 && row.status!=2" class="right tiny-btn-0" @click="action(4)">支付费用</div>-->
<!--          </div>-->
<!--        </van-step>-->
<!--        <van-step>-->
<!--          <div class="step-li">-->
<!--            <div class="title">报名成功</div>-->
<!--            <p class="desc">报名成功</p>-->
<!--          </div>-->
<!--        </van-step>-->
<!--      </van-steps>-->
<!--    </div>-->

    <div class="shareShow" v-if="showWxShare" @click="showWxShare=false">
      <div>
        <h2>点击分享给好友(朋友圈)</h2>
      </div>
    </div>
<!--    <div class="savebtn" v-if="row.score_status == 3">-->
<!--      <van-button-->
<!--          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"-->
<!--          style="width: 3rem"-->
<!--          size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="onOrder">-->
<!--        确认订单并支付-->
<!--      </van-button>-->
<!--    </div>-->

    <van-button
        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
        style="position:fixed;bottom: 80px;left: 10px;width: 2rem"
        size="normal" round @click="onTemplateShow">批量导入
    </van-button>
    <van-button
        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
        style="position:fixed;bottom: 80px;right: 10px;width: 2rem"
        size="normal" round @click="onMemberDownload">数据导出
    </van-button>

    <div class="savebtn">
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 2rem"
          size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="onShare">
        分享二维码至微信群
      </van-button>

      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 2rem"
          size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="action(2)">
        手动录入
      </van-button>

      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 2rem"
          size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="action(3)">
        支付费用
      </van-button>
    </div>

    <van-dialog v-model="showTemplate" title="导入模板信息" :showCancelButton="true" :showConfirmButton="false" confirmButtonText="导入模板" style="text-align: center">
      <div class="operate-desc-left">复制下面的链接，用电脑端打开，进行批量导入操作</div>
<!--      <div class="operate-desc-left" @click="download" style="color: #1989fa;">考级人员批量导入模版下载</div>-->
      <div class="operate-desc-left" v-clipboard:copy="template_share"
           v-clipboard:success="onCopy"
           v-clipboard:error="onError" style="color: #666">导入模板链接地址：{{template_share}} <div class="small-button">复制</div></div>
<!--      <van-uploader-->
<!--          accept=".xls,.xlsx"-->
<!--          :after-read="readFile"-->
<!--      >-->
<!--        <van-button-->
<!--            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"-->
<!--            style="width: 3rem;margin-bottom: .2rem"-->
<!--            size="normal" round>导入模板-->
<!--        </van-button>-->
<!--      </van-uploader>-->
    </van-dialog>

    <van-popup :close-on-click-overlay="false" v-model="showLoading">
      <div class="circle-div">
        <van-circle :stroke-width="60" :color="{
                                '0%': '#ffad19',
                                '100%': '#fec835',
                              }" v-model="progress" :rate="progress" :speed="100" :text="progress+'%'"/>
        <van-button
            style="width: 3rem; margin-top: 10px"
            size="normal" round>上传中
        </van-button>
      </div>
      <div>
      </div>

    </van-popup>

    <van-dialog v-model="showError" title="批量导入错误信息">
      <van-cell-group>
        <van-cell :title="item" v-for="item in errorMsg"/>
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 30px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
  display: inline-block;
}

.circle-div {
  text-align: center;
}

.circle-div >>> .van-circle__text {
  color: #fff !important;
}

.tiny-btn-1 {
  top: 30px !important;
}

.step-warp {
  margin: 0.2rem;
  border-radius: 0.2rem;
  padding: 0.2rem;
  background: #fff;
}

.step-warp .step-li {
  color: #000;
  position: relative;
}

.step-warp .step-li .title {
  font-size: 14px;
}

.step-warp .step-li .desc {
  margin-top: 0.2rem;
  font-size: 12px;
  color: #666;
}

.step-warp .right {
  position: absolute;
  top: 0;
  right: 0;
}

.danwei-warp {
  margin: 0.2rem;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(204, 204, 204, 0.5);
  border-radius: 0.2rem;
  padding: 0.2rem;
}

.danwei-warp .title {
  font-size: 18px;
  color: #000;
  margin: 0.4rem 0.2rem 0.2rem 0.2rem;
  font-weight: bold;
}

.danwei-warp .saiqu {
  font-size: 14px;
  margin: 0rem 0.2rem 0.4rem 0.2rem;
  color: #666;
}

.danwei-warp .duiwu {
  font-size: 12px;
  margin: 0.4rem 0.2rem 0rem 0.2rem;
  color: #999;
}

.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  Steps,
  Step,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
import XLSX from "xlsx";

Vue.use(Cell).use(CellGroup).use(Steps).use(Step).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ExameApplyDetailMine',
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      loading: true,
      showWxShare: false,
      showTemplate: false,
      saiqu_id: this.$route.query.saiqu_id,
      showCaipanPicker: false,
      showJiaolianPicker: false,
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      starText: '',
      row: {
        id: 0,
        saiqu_name: '',
        numTypeName: '身份证',
        danwei: '',
        memberstatus: 0,
        ldcardtype: 1,
        ldsex: 1,
        member_list: [],
        saiqu: {},
        heying: [{
          name: "选择商户.png",
          save_name: "h5/2020-05-11/1589187988243621.png",
          uid: "vc-upload-1589187988243621",
          url: "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
        }],
        caipan: [],
        jiaolian: [],
      },

      listData: [],
      startNum: 3,
      formData: {
        grade: '',
        csize: '',
        num: '',
        numtype: 1,
        birthday:'',
        sex:1,
        is_exam_continue: 2,
        kaoji_id: this.$route.query.id,
        share_id: 0,
        name: '',
        score_total: 0
      },

      template_share: '',
      errorMsg: [], // 错误列表
      progress: 0,
      showLoading: false,
      showError: false,
    }
  },
  filters: {},
  computed: {
    active() {
      switch (this.row.status) {
        case 1:
          return 2;
          break;
        case 2:
          return 4;
          break;
        default:
          return 1;
      }
    }
  },
  mounted() {
    let that = this;
    that.areaList = area;
    that.row.id = this.$route.query.id;
    document.title = "考级详情"

    this.fetch();

    window.rbMessage = function (data) {
      if (data == 'saiApplyDetailReload') {
//                    alert('that.fetch()')
        that.fetch();
      }
    }
  },
  watch: {},
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get('/api/qcxj/applyDetail', {
        id: that.row.id,
      }, (res) => {
        that.row = res.data;
        that.loading = false
        res.data.star_type.map(item => {
          that.starText.concat(item.text + ' ')
        })
      })
    },
    onShare() {
      let that = this
      that.$api.post('/api/qcxj/kaojiApplyShareSimpleData', {
        kaoji_id: that.row.id
      }, (res) => {
        that.shareWeixinFriend(res.data);
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    onOrder() {

    },

    shareWeixinFriend(share_data){
      console.log('shareWeixinFriend')
      let that = this;
      if(window.isApp()){
        appEvent({
          name: 'shareWeixinFriend',
          query: share_data
        });
      }else{
        this.showWxShare = true;
        this.show_share_panel = false;
        that.wxShare(share_data.title,share_data.desc,share_data.url,share_data.pic_url );
      }
    },
    action(type) {
      switch (type) {
        case 1 :
          rbLink({
            name: 'ExameApplyMemberList', query: {kaoji_id: this.row.id}
          });
          break;

        case 2:
          rbLink({
            name: 'ExameApplyMemberAdd', query: {kaoji_id: this.row.id, share_id: 0}
          });
          break;

        case 3:
          rbLink({
            name: 'ExameApplyOrderMine', query: {id: this.row.id}
          });
          break;
        case 4:
          rbLink({
            name: 'ExameApplyOrder', query: {id: this.row.id}
          });
          break;
      }
    },

    download(){
      console.log('donwload')
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: '考级人员信息导入表模板',
          url:'https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-16/1626404860889325.xlsx'
        }
      });
    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    onTemplateShow() {
      let that = this

      that.$api.post('/api/qcxj/applyDetailShare', {
        id: this.$route.query.id
      }, (res) => {
        that.template_share = res.data
        that.showTemplate = true
      }, (res) => {

      })
    },

    onMemberDownload() {
      let that = this
      that.$api.post('/api/qcxj/kaojiMemberDownload', {
        id: this.$route.query.id
      }, (res) => {
        let path = root + res.data.path

        appEvent({
          name: 'downloadFile',
          query: {
            name: res.data.name,
            url: path
          }
        });
        console.log(res, root, path)
      }, (res) => {

      })
    },

    readFile(evt) {
      console.log('------readFile------', evt)
      var that = this;
      that.errorMsg = []
      that.index = 0

      that.showTemplate = false

      let files = {0: evt.file}

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          if (that.startNum) {
            list = list.splice(that.startNum, list.length)
          }

          that.listData = list
          // let listData = list.filter(row => {
          //   return row.hasOwnProperty("__EMPTY");
          // })
          console.log('onGetData', list)
          // return
          that.formatData()

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },

    formatData() {
      let that = this
      that.showLoading = true
      that.listData.map((row) => {
        that.addRow(row)
      })
    },

    addRow(row) {
      let that = this
      that.formData.name = row['__EMPTY']
      that.formData.sex = row['__EMPTY_1'] === '男'? 1 : 2
      that.formData.phone = row['__EMPTY_2'] ? row['__EMPTY_2'] : ''
      that.formData.num = row['__EMPTY_3'] ? row['__EMPTY_3'] : ''
      that.formData.totalscore = row['__EMPTY_4'] ? row['__EMPTY_4'] : ''

      let grade = '红'
      if(row['__EMPTY_5'] === 1) {
        grade = '红';
      } else if(row['__EMPTY_6'] === 1) {
        grade = '橙';
      }else if(row['__EMPTY_7'] === 1) {
        grade = '黄';
      }else if(row['__EMPTY_8'] === 1) {
        grade = '绿';
      }else if(row['__EMPTY_9'] === 1) {
        grade = '青';
      }else if(row['__EMPTY_10'] === 1) {
        grade = '蓝';
      }else if(row['__EMPTY_11'] === 1) {
        grade = '紫';
      }
      that.formData.grade =grade

      console.log(that.formData)
      // return
      that.kaojiMemberAdd()
    },

    kaojiMemberAdd() {
      let that = this
      that.$api.post('/api/qcxj/applyMemberAddAll', that.formData, (res) => {

        that.getProgress()
        // that.onRefresh();
        that.formData = {
          grade: '',
          csize: '',
          num: '',
          numtype: 1,
          birthday:'',
          sex:1,
          is_exam_continue: 2,
          kaoji_id: this.$route.query.id,
          share_id: 0,
          name: '',
          score_total: 0
        };
      }, (res) => {
        if (res.code === 600) {
          that.errorMsg.push(res.msg)
        }
        that.getProgress()
      })
    },

    getProgress() {
      let that = this
      that.index += 1

      let index = that.index,
          list = that.listData

      // console.log(that.errorMsg, index, list.length)

      that.progress = parseInt((index / list.length) * 100).toFixed(0)
      if (index === list.length) {
        that.showLoading = false
        that.fetch()

        if (that.errorMsg.length > 0) {
          // 唤起弹框
          that.showError = true

        } else {
          Toast.success('批量导入成功')
        }
      }
    },

    onQuestion() {
      console.log('onQuestion')
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// ExameApplyDetailMine.vue?31aa7f07